import styled from 'styled-components'

export const DropdownWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 500px;
`
